import { render } from "./TutorialModal.vue?vue&type=template&id=19df8f4a&ts=true"
import script from "./TutorialModal.vue?vue&type=script&lang=ts"
export * from "./TutorialModal.vue?vue&type=script&lang=ts"

import "./TutorialModal.vue?vue&type=style&index=0&id=19df8f4a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__